<template>
  <div>
    <ul class="breadcrumb">
      <li>
        <router-link :to="{name: 'Warehouses'}">倉庫管理TOP</router-link>
      </li>
      <li v-for="item in breadcrumbs" :key="item.id" :id="item.id">
        {{ item.title }}
      </li>
    </ul>
  </div>
</template>
<script>
import tabs from '@/common/warehouse-sc-tabs'

export default {
  props: {
    tab: {
      type: String,
      default: 'top'
    },
    subTab: {
      type: String,
      default: ''
    }
  },
  computed: {
    breadcrumbs () {
      let currentTab = tabs.find(item => item.id === this.tab)
      let breadcrumbs = [currentTab]
      if (this.subTab && currentTab.childs) {
        let subTab = currentTab.childs.find(item => item.id === this.subTab)
        if (subTab) {
          breadcrumbs.push(subTab)
        }
      }
      return breadcrumbs
    }
  }
}
</script>

<style scoped>
.breadcrumb {
  padding: 0 15px;
  background-color: #f1f3f6;
}
.breadcrumb > li + li:before {
  padding: 0 3px;
  color: #000;
  content: ">";
}
a {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/view/warehouseSc/components/Breadcrumb.vue